/**
 * @author Jensen<zhhnch@gmail.com>
 * @description cookie控制功能
 * @since 2017/6/5
 */
import { getType, getInstance } from './tool'

const SAVE_TIMEOUT = 86400 // 默认3600秒

export class CookieUtil {
  /**
   * cookie字符串转为map
   * @param str
   * @returns {{}}
   */
  static toMap (str) {
    let map = {}
    let arr = str.split(';')
    arr.forEach((cookieNode) => {
      let [k, v] = CookieUtil._nodeToArr(cookieNode)
      if (k) {
        map[k] = v
      }
    })
    return map
  }

  /**
   *
   * @param map
   * @returns {string}
   */
  static toStr (map) {
    let arr = []
    Object.keys(map).forEach((key) => {
      if (key && getType(key) === 'string') {
        arr.push(key + '=' + map[key])
      }
    })
    return arr.join('; ')
  }

  /**
   * cookie键值对转为数组
   * @param {string} str "key=value"
   * @returns {Array} [key, value]
   * @private
   */
  static _nodeToArr (str) {
    let arr = str.split('=')
    return arr.map((item) => {
      return decodeURIComponent(item.trim())
    })
  }
}

export class CookieReader {
  /**
   * 将cookie字符串转为对象
   * @returns {{}}
   */
  static read () {
    return CookieUtil.toMap(document.cookie)
  }

  /**
   * 根据key获取cookie的值
   * @param key
   * @returns {*}
   */
  static getCookie (key) {
    let cookieMap = CookieReader.read()
    if (getType(key) === 'undefined') {
      return cookieMap
    }
    return cookieMap[key]
  }
}

export class CookieWriter {
  /**
   * @param map
   */
  static write (map) {
    document.cookie = CookieUtil.toStr(map)
  }
}

class CookieHelper {
  static getInstance = getInstance((host) => new CookieHelper(host));
  /**
   * cookie 域名
   * @type {string}
   * @private
   */
  _host = '';
  _cookieMap = {};

  constructor (host) {
    this._host = host
    this._initCookieMap()
  }

  /**
   * @private
   */
  _initCookieMap () {
    this._cookieMap = CookieReader.read()
  }

  /**
   * 保存cookie
   * @param {string} key cookie名称
   * @param {string} val cookie值
   * @param {string} second cookie时效，以秒为单位
   * @param {string} host cookie站点
   */
  setCookie (key, val, second = SAVE_TIMEOUT, host) {
    host = host || this._host
    key = encodeURIComponent(key)
    let cookieMap = {
      [key]: encodeURIComponent(val)
    }
    if (host) {
      cookieMap.domain = host
    }
    if (second > 0) {
      cookieMap.expires = CookieHelper.getExpires(Date.now() + second * 1000)
    }
    cookieMap.path = '/'
    CookieWriter.write(cookieMap)
  }

  /**
   * 一次性保存多个cookie的值
   * @param cookieMap
   * @param second
   * @param host
   */
  setCookies (cookieMap, second, host) {
    for (let key in cookieMap) {
      if (cookieMap.hasOwnProperty(key)) {
        this.setCookie(key, cookieMap[key], second, host)
      }
    }
  }

  /**
   * @param {number} t
   * @returns {string}
   */
  static getExpires (t) {
    return (new Date(t)).toUTCString()
  }

  /**
   * 获取cookie
   * @param {string|*} key
   * @returns {object|string|undefined}
   */
  getCookie (key) {
    this._initCookieMap()
    if (getType(key) === 'undefined') {
      return this._cookieMap
    }
    return this._cookieMap[key]
  }

  /**
   * 删除指定的cookie
   * @param {string} key cookie名称
   */
  clearCookie (key) {
    let cookieMap = {
      [key]: ''
    }
    cookieMap.expires = CookieHelper.getExpires(0)
    cookieMap.path = '/'
    CookieWriter.write(cookieMap)
    cookieMap.domain = this._host
    CookieWriter.write(cookieMap)
  }

  /**
   * 清空所有的cookie
   */
  clearAll (host) {
    this._initCookieMap()
    host = host || this._host
    Object.keys(this._cookieMap).forEach((key) => {
      let cookieMap = {
        [key]: '',
        expires: CookieHelper.getExpires(0),
        domain: host,
        path: '/'
      }
      CookieWriter.write(cookieMap);
      cookieMap.domain = this._host;
      CookieWriter.write(cookieMap);
    })
  }
}
export default CookieHelper


// WEBPACK FOOTER //
// ./src/utils/cookieHelper.js